
import { defineComponent } from "vue";

export default defineComponent({
  name: "PopUp",
  props: {
    text: {
      type: String,
      required: true,
      default: "",
    },
    nextFunction: {
      type: Function,
      required: false,
      default: () => {
        return;
      },
    },
    buttonText: {
      type: String,
      required: false,
      default: "閉じる",
    },
  },
  setup(props) {
    let closed = false;
    let timerId = 0;
    const close = () => {
      if (closed) return;
      closed = true;
      clearTimeout(timerId);
      props.nextFunction();
    };
    timerId = window.setTimeout(close, 3000);
    return {
      close,
    };
  },
});
